/**
 * Resolve stored assessment answer for display (audit detail, print).
 * Supports checklist { value: 'DA'|'NU'|'N/A' } and scored option values.
 */

export function getRawAnswerValue(answers, question) {
  if (!answers || !question) return null;
  const raw = answers[question.id] ?? answers[question.code];
  if (raw == null) return null;
  if (typeof raw === 'object' && raw !== null && 'value' in raw) {
    return raw.value;
  }
  return raw;
}

export function formatAssessmentAnswer(answers, question, useRo = true) {
  const value = getRawAnswerValue(answers, question);
  if (value == null || value === '') return '—';

  if (value === 'DA' || value === 'NU' || value === 'N/A') {
    return value;
  }

  const opt = (question.options || []).find((o) => o.value === value);
  if (opt) {
    return useRo
      ? opt.labelRo || opt.label || String(value)
      : opt.label || opt.labelEn || opt.labelRo || String(value);
  }

  return String(value);
}

export function answerDisplayClass(value) {
  if (value === 'DA') return 'answer-yes';
  if (value === 'NU') return 'answer-no';
  return 'answer-na';
}
